/**
 * Отбор в дереве проектов.
 *
 * Вынесен из компонента, потому что это чистое дерево и чистая функция:
 * проверять её вызовом дешевле, чем мышью, а ошибка здесь тихая — список
 * просто покажет не то.
 */

/** Узел дерева: важны только имя и дети, остальное отбору безразлично. */
export interface TreeNode {
  id: number;
  name: string;
  children: TreeNode[];
}

/** Строка для сравнения: регистр и «ё» в названиях пишут как придётся. */
export function normalize(text: string): string {
  return text.trim().toLowerCase().replaceAll("ё", "е");
}

/**
 * Оставить совпавшие узлы и их родителей.
 *
 * Родитель попадает в выдачу, даже если сам не совпал: без него найденный
 * подпроект висит в воздухе, и непонятно, что это за «Ядро» и чьё. Совпавший
 * узел, наоборот, приходит со всеми детьми — раз спросили про «Разработку»,
 * показывать её наполовину незачем.
 */
export function filterTree<T extends TreeNode>(nodes: T[], query: string): T[] {
  const needle = normalize(query);
  if (needle === "") {
    return nodes;
  }

  const kept: T[] = [];
  for (const node of nodes) {
    if (normalize(node.name).includes(needle)) {
      kept.push(node);
      continue;
    }
    const children = filterTree(node.children as T[], query);
    if (children.length > 0) {
      kept.push({ ...node, children });
    }
  }
  return kept;
}
